import { render } from "./TagSearchSelect.vue?vue&type=template&id=53ef2d06&scoped=true"
import script from "./TagSearchSelect.vue?vue&type=script&lang=js"
export * from "./TagSearchSelect.vue?vue&type=script&lang=js"

import "./TagSearchSelect.vue?vue&type=style&index=0&id=53ef2d06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53ef2d06"]])

export default __exports__